import { render } from "./OrderStatus.vue?vue&type=template&id=412bbd0a&scoped=true"
import script from "./OrderStatus.vue?vue&type=script&lang=js"
export * from "./OrderStatus.vue?vue&type=script&lang=js"

import "./OrderStatus.vue?vue&type=style&index=0&id=412bbd0a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-412bbd0a"],['__file',"src/views/Dashboard/OrderStatus.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "412bbd0a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('412bbd0a', __exports__)) {
    api.reload('412bbd0a', __exports__)
  }
  
  module.hot.accept("./OrderStatus.vue?vue&type=template&id=412bbd0a&scoped=true", () => {
    api.rerender('412bbd0a', render)
  })

}


export default __exports__